export default {
  // backend codes
  '0404': 'El recurso no se encuentra disponible',
  '0401': 'No se encuentra autenticado',
  '0403': 'No tienes permisos para realizar esta acción',
  '0400': 'Se ha producido un error con la solicitud',
  '0413': process.env.REACT_APP_MAX_UPLOAD_SIZE_ERROR_MESSAGE,
  '0500': 'Ha ocurrido un error intente más tarde',

  // auth
  '0001': 'Nombre de usuario o contraseña incorrecta',

  // unsupported image format
  '0002': 'Formato de imagen no soportado',
  '0004': 'Hubo un problema con la imagen, vuelva a subirla',

  'OK': 'Ok',
  'SAVE': 'Guardar cambios',
  'CANCEL': 'Cancelar',

  // message fronend
  'CREATE_ENTITY': 'Crear {{entity}}',
  'EDIT_ENTITY': 'Editar {{entity}}',
  'DELETE_ENTITY': 'Eliminar {{entity}}',
  'DELETE_MESSAGE': 'Estás seguro que quieres eliminar {{name}} de tus {{entity}}s?',
  'DELETE': 'Eliminar',
  'CONFIRM': 'Confirmar',
  'SUCCESSFUL_UPDATE': 'Actualizado con éxito',
  'UPDATE_BUTTON': 'Actualizar',

  'MENU': {
    'EDIT_BRAND': 'Editar datos de la empresa',
    'LOG_OUT': 'Salir',
    'CUSTOMER_SUCCESS_PASSWORD': 'Contraseña: wifimarketing'
  },

  'FORM_VALIDATION': {
    'REQUIRED': 'El campo es obligatorio',
    'MAX_SIZE_IMAGE': 'Tamaño del archivo debe ser menor a 2MB',
    'UNSUPPORTED_FORMAT': 'Formato de imagen no soportado',
  },

  'NUMBERS': {
    'MUST_BE_NUMBER': 'Debe ser un número',
  },

  'IMAGE_UPLOADER': {
    'TITLE': 'Una imagen para subir',
    'TEXT': 'Agrega una imagen aquí, o haz click',
    'HINT': 'Tamaño de imagen menor a 2MB.\n\nFormatos soportados: jpg, jpeg, png, gif, bmp.',
    'ERROR_MESSAGE': 'No podemos subir la imagen',
  },

  'DATE_PICKER': {
    'TITLE': 'Selecciona una fecha',
    'PRIMARY_BUTTON_TEXT': 'Continuar',
    'SECONDARY_BUTTON_TEXT': 'Cancelar',
  },

  'TIME_PICKER': {
    'TITLE': 'Selecciona un hora',
    'PRIMARY_BUTTON_TEXT': 'Guardar',
    'SECONDARY_BUTTON_TEXT': 'Volver al calendario',
  },

  'CONTACT_US_TEXT': 'Si necesitas ayuda o presentas algún problema con la aplicación llama al 800 123 9434',
  'PLACEMENT_SELECTOR_TITLE': 'Seleccionar sitios',
  'INTL_NUMBER': '{{value, intlNumber}}',
  'INTL_NUMBER_WITH_ONE_DECIMAL': '{{value, intlNumberWitOneDecimal}}',
  'INTL_PERCENT': '{{value, intlPercent}}',
  'INTL_PERCENT_WITH_ONE_DECIMAL': '{{value, intlPercentWitOneDecimal}}',
  'INTL_CURRENCY': '{{value, intlCurrency}}',
}
